/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const searchChallengeResultSchema = z.object({
  id: z.number(),
  title: z.string(),
  cefrLevel: z.string(),
  type: z.string(),
  slug: z.string(),
});

export type ISearchChallengeResult = z.infer<typeof searchChallengeResultSchema>;

export const searchChallengesResponseSchema = createApiResponseSchema(
  z.array(searchChallengeResultSchema),
) as z.ZodSchema<IAPI<ISearchChallengeResult[]>>;
